import React  from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip} from "react-bootstrap";
import { minutesToHourAndMinutes } from "../helpers/HelperFunctions";

const TaskLog = (props) => {
 
	const renderToolTip = (log) => {
		if (log.allDay) {
			const { hours, minutes } = minutesToHourAndMinutes(log.time);
			return <Tooltip id={log.id}>
				<h5 className="event-text">
					<strong>Total:</strong> <span className="event-value"> {hours > 0 ? `${hours}h` : `${0}h`} { minutes > 0 ? ` and ${minutes}min` : null}</span> 
				</h5>
			</Tooltip>;
		} 

		const time = minutesToHourAndMinutes(log.time);
		return <Tooltip id={log.id}>
			<h5 className="event-text"> <strong>Project:</strong> <span className="event-value">{log.project_name}</span> </h5>
			<h5 className="event-text"> <strong>Task:</strong> <span className="event-value">{props.title}</span> </h5>
			<h5 className="event-text"> <strong>Time:</strong>  <span className="event-value">{time.hours}h and {time.minutes}min</span> </h5>
			<h5 className="event-text"> <strong>Description:</strong> <span className="event-value">{log.description}</span> </h5>
		</Tooltip>;
	};
	
	return (
		<React.Fragment>
			{props.allDay ? 
				<OverlayTrigger  overlay={renderToolTip(props)} placement="top" delayShow={100} delayHide={100}>
					<span className="event-item">{(props.title/60).toFixed(1)}h</span> 
				</OverlayTrigger>
				:
				<OverlayTrigger  overlay={renderToolTip(props)} placement="top" delayShow={100} delayHide={100}>
					<span className="event-item">{props.title}</span> 
				</OverlayTrigger>
			}
		</React.Fragment>
	);
};

TaskLog.defaultProps = { allDay: null };

TaskLog.propTypes = {
	// id: PropTypes.number.isRequired,
	// time: PropTypes.number,
	title: PropTypes.string.isRequired,
	allDay: PropTypes.string,
	// description: PropTypes.string.isRequired
};

export default TaskLog;


// WEBPACK FOOTER //
// ./src/components/partials/TaskLog.js